import React from "react";

/** Niox typically capitalizes their name. */
// export const renderNioxText = () => <>NIOX<sup>®</sup></>;
export const renderFenoText = () => "FeNO";
export const renderFenoTypeText = (fenoType?: 'niox' | 'nobreath') => {
  if (fenoType === 'niox') {
    return <>NIOX<sup>®</sup></>;
  } else if (fenoType === 'nobreath') {
    return <>NObreath<sup>®</sup></>;
  } else {
    return <></>;
  }
};
export const renderNioxFenoText = (fenoType?: 'niox' | 'nobreath') => <>{renderFenoTypeText(fenoType)} {renderFenoText()}</>;

export const NioxFenoKioskRoute = "/kiosk/niox-feno";

export const NioxIPCServerVersion = "0.1.0";
